import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig, DwLookupInfo, DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { PaymentRepositoryService } from '../../services/payment-repository.service';
import { CheckRideRequestEntity, CheckRideRequestPaymentPartyAllItems, PaymentCustomerReferenceEntity } from '../../../../meta-data/app-meta-data.service';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { PilexosUserTypeIds } from '../../../shared/models/pilexos-user-type.enum';
import { PaymentMethodUtilService } from '../../services/payment-method-util.service';
import { PaymentAddCardResult } from '../../models/payment-add-card-result.model';
import { distinctUntilChanged } from 'rxjs/operators';

@DwComponent({
  key: 'pilexos-card-selection-control',
  name: 'Payment Card Selection',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-card-selection-control',
  template: `
    <div>
      <p-dropdown [options]="cardList" [resetFilterOnHide]="true" optionLabel="Display" display="chip" optionValue="Id" [(ngModel)]="currentCardValue" (ngModelChange)="cardValueChange($event)" [showClear]="false" [style]="{'width':'100%'}" [filter]="false" scrollHeight="300px" appendTo="body">
              <ng-template let-item pTemplate="item">
                  <div *ngIf="item && item[valueAttrName] !== ADD_NEW_ITEM">
                      {{item?.Display}} 
                  </div>
                  <div *ngIf="item && item[valueAttrName] === ADD_NEW_ITEM">
                      <i [ngClass]="item?.IconClass"></i> {{item?.Display}}
                  </div>
              </ng-template>
      </p-dropdown>

      <!--<select class="form-control" [(ngModel)]="currentCardValue" (ngModelChange)="cardValueChange($event)" formControlName2 ="fieldDef?.attrName" [id]="fieldDef?.attrName  || ''">
        <option [ngValue]="null">Select Card</option>  
        <option ngValue="add-new"><i class="fa fa-plus-circle dw-green"></i> Add Card</option>
        <option *ngFor="let card of customer?.PaymentCard" [ngValue]="card.CardReferenceKey">
        {{card.CardName}}
        </option>
      </select>-->
    </div>
  `
})
export class CardSelectionControlComponent implements DwFormControl, DwFormControlInit {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  context: DwContext;
  useDisplayField?: boolean;

  formattedDuration: string;
  customer: PaymentCustomerReferenceEntity;
  partyId: CheckRideRequestPaymentPartyAllItems;
  lastCard: any;
  paymentAddCardResult: PaymentAddCardResult;

  ADD_NEW_ITEM = 'add-new';

  currentCardValue: string;

  valueAttrName = 'Id';

  cardList: DwLookupInfo[] = [];

  constructor(
    private paymentRepositoryService: PaymentRepositoryService,
    private adminManagerService: AdminManagerService,
    private paymentMethodUtilService: PaymentMethodUtilService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
  ) { }

  showingModal = false;

  ngOnInit() {
    const user = this.adminManagerService.getPilexosUser();

    this.partyId = CheckRideRequestPaymentPartyAllItems.FlightSchool;

    if (user.UserTypeId == PilexosUserTypeIds.pilotExaminer) {
      this.partyId = CheckRideRequestPaymentPartyAllItems.FlightSchool;
    }

    this.setupCards();

    this.dwMetaDataFormStateService.state.formContext.loadDataComplete;
  }

  initControl(): void {
    // this.control.valueChanges
    // .pipe(distinctUntilChanged())
    // .subscribe(value => {
    //   if (value == this.lastCard) {
    //     return;
    //   }

    //   this.lastCard = value;

    //   if (value == 'add-new') {
    //     this.showAddCardModal();
    //     return;
    //   }
    // });
  }

  cardValueChange(value: any) {
    if (value == this.lastCard) {
      return;
    }

    this.lastCard = value;

    if (value == this.ADD_NEW_ITEM) {
      this.showAddCardModal();
      return;
    }

    this.control.setValue(value);
  }

  private setupCards(forceSet?: boolean) {
    this.paymentRepositoryService.getCustomer(this.partyId)
      .subscribe((customer) => {
        this.customer = customer;

        this.buildCardList();

        this.setCurrentCard(forceSet);
      });
  }


  private buildCardList() {
    this.cardList = this.customer?.PaymentCard?.map(card => { return { Id: card.CardReferenceKey, Display: card.CardName } as DwLookupInfo; }) || [];

    let blankItem: DwLookupInfo = {
      Display: " ",
      Id: null,
    };

    this.cardList.splice(0, 0, blankItem);


    const addItem: DwLookupInfo = {
      Display: 'Add New',
      Id: this.ADD_NEW_ITEM,
      IconClass: 'fa fa-plus-circle dw-green',
    };

    this.cardList.splice(1, 0, addItem);


  }

  setCurrentCard(forceSet?: boolean) {
    if (this.control?.value && !forceSet) {
      this.currentCardValue = this.control?.value;
      return;
    }
    if (this.paymentAddCardResult?.PaymentCardReferenceKey) {
      this.currentCardValue = this.paymentAddCardResult.PaymentCardReferenceKey;
      this.control?.setValue(this.currentCardValue);
      return;
    }

    const defaultCard = this.customer?.PaymentCard?.find(card => card.IsDefaultCard);
    if (defaultCard) {
      this.currentCardValue = defaultCard.CardReferenceKey;
      this.control?.setValue(this.currentCardValue);
      return;
    }

    this.currentCardValue = null;

    this.control?.setValue(this.currentCardValue);
  }

  showAddCardModal() {

    if (this.showingModal) {
      return;
    }

    this.showingModal = true;

    console.log('Showing add card modal for party id ' + this.partyId);
    this.paymentMethodUtilService.showAddCardModal({ paymentPartyId: this.partyId })
      .subscribe((modalResult) => {
        this.showingModal = false;
        if (!modalResult.cancelled) {
          this.paymentAddCardResult = modalResult.data;

          this.setupCards(true);
          return;
        }

        this.setCurrentCard(true);
      });

  }

  /*
   * Returns the rating Form Control to get or set it's value
   */
  get control(): AbstractControl {
    return this.formGroup.get(this.fieldDef.attrName);
  }
}
